import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=42a38741&scoped=true&"
import script from "./SingleSelect.vue?vue&type=script&lang=js&"
export * from "./SingleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a38741",
  null
  
)

export default component.exports